import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import Link from 'next/link';
import { FC, useMemo } from 'react';
import Marquee from 'react-fast-marquee';
import Text from '~/components/Text';
import { PATH } from '~/constants/enum';
import { QUERY_GET_ALL_REVIEWS_ONLY_IMG } from '~/data/home';
import { ReviewItem } from '~/data/product/interfaces';
import styles from './Testimonial.module.scss';

interface TestimonialVer2Props {
    backgroundImage?: string;
    siteReviews?: any;
}

const TestimonialVer2: FC<TestimonialVer2Props> = ({ backgroundImage = '/images/testimonial.png', siteReviews }) => {
    const _siteReviews: ReviewItem[] = useMemo(() => {
        const allReview = siteReviews?.allReview?.items || [];

        return allReview;
    }, [siteReviews?.allReview?.items]);

    const testimonials = _siteReviews || [];

    if (!testimonials.length) {
        return null;
    }

    return (
        <div
            className={classNames(
                styles.section_bg,
                'flex flex-col justify-center items-center pb-10 pt-8 md:pb-20 md:pt-16'
            )}
            style={{ backgroundImage: `url("${backgroundImage}")` }}
        >
            <div className="mb-2 md:mb-4">
                <div className="relative ">
                    <span className={styles.happyCustomers}>HAPPY CUSTOMERS</span>
                </div>
            </div>
            <Marquee speed={100} pauseOnHover={true}>
                <div className="flex items-center">
                    {testimonials.map((item, index) => (
                        <div key={index} className="flex flex-col items-center w-[195px] !mx-4 md:w-[300px] md:!mx-6">
                            {item?.product.sku === 'REVIEW' ? (
                                <div className="w-full">
                                    <div className="flex flex-col items-start">
                                        <img
                                            src={item?.images[0] || item?.product?.thumbnail?.url || ''}
                                            alt="Customer's avatar"
                                            className="rounded-sm w-full h-auto object-cover max-h-[313px] md:max-h-[460px]"
                                        />
                                        <div className="mt-5">
                                            <Text type="body-1" className="text-white line-clamp-3 !text-[15px]">
                                                {item?.text}
                                            </Text>
                                            <p className="font-bold text-white text-[15px] mt-3 !mb-0">
                                                {item?.nickname}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <a
                                    href={PATH.ProductDetail.replace('[slug]', item?.product?.url_key || '')}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-start">
                                        <img
                                            src={item?.images[0] || item?.product?.thumbnail?.url || ''}
                                            alt="Customer's avatar"
                                            className="rounded-sm w-full h-auto object-cover max-h-[313px] md:max-h-[460px]"
                                        />
                                        <div className="mt-5">
                                            <Text type="body-1" className="text-white line-clamp-3 !text-[15px]">
                                                {item?.text}
                                            </Text>
                                            <p className="font-bold text-white text-[15px] mt-3 !mb-0">
                                                {item?.nickname}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            </Marquee>
        </div>
    );
};

export default TestimonialVer2;
